import {ChangeDetectionStrategy, Component, Inject, WritableSignal, computed, effect, signal} from '@angular/core';
import {PageComponent} from 'src/app/layout/pages/page/page.component';
import {KeycloakProfile} from "keycloak-js";
import {KeycloakService} from "keycloak-angular";
import { CommonModule } from '@angular/common';
import { DashboardCardComponent } from "../components/dashboard-card/dashboard-card.component";
import { AuthService } from 'src/app/core/services/auth.service';
import { PUNTICAMPIONAMENTO_VISIBLECOLUMNS, PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD, PUNTI_CAMPIONAMENTO_COLUMNS, PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE } from '../../punti-campionamento/punti-campionamento.config';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PuntiCampionamentoService } from '../../punti-campionamento/punti-campionamento.service';
import { IPuntoCampionamento } from '../../punti-campionamento/punti-campionamento.model';
import { PageListComponent } from "../../../layout/pages/page-list/page-list.component";
import { MapsFieldComponent } from "../../../shared/components/fields/maps-field/maps-field.component";
import { DashboardMapComponent } from "../components/dashboard-map/dashboard-map.component";
import { MatDividerModule } from '@angular/material/divider';
import { QueryService } from 'src/app/core/services/query.service';
import { GPS_ENDPOINT_QUERY_SERVICE_INSTANCE } from '../dashboard.config';
import { Router } from '@angular/router';


@Component({
    standalone: true,
    selector: 'app-dashboard-page',
    templateUrl: './dashboard-page.component.html',
    styleUrls: ['./dashboard-page.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MatDividerModule,
        PageComponent,
        DashboardCardComponent,
        PageListComponent,
        MapsFieldComponent,
        DashboardMapComponent
    ]
})
export class DashboardPageComponent {
  columns = PUNTI_CAMPIONAMENTO_COLUMNS;
  visibleColumns = signal(PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD);
  insertForm: FormGroup;
  filterForm: FormGroup;
  data = this.queryService.store.selectKey('list');
  public isLoggedIn = false;
  public userProfile: WritableSignal<KeycloakProfile | null> = signal(null);
  public username = computed(() => this.authService.user()?.username || '');
  customClickFunction:Function=(row:any)=>{

    if(row.uuid){
      this.navigateToDetail(row.uuid.toString())
    }

  }
  constructor(
    private readonly keycloak: KeycloakService,
    private authService: AuthService,
    private readonly fb: FormBuilder,
    public readonly service: PuntiCampionamentoService,
    @Inject(PUNTI_CAMPIONAMENTO_QUERY_SERVICE_INSTANCE) public readonly queryService: QueryService<IPuntoCampionamento>,
    private router: Router
  )
   {
    this.insertForm = this.fb.group<IPuntoCampionamento>(<IPuntoCampionamento>{});
    this.filterForm = this.fb.group({
      search: this.fb.control('', []),
      filters: this.fb.group({})
    });
  }

  async ngOnInit() {
    this.isLoggedIn = this.keycloak.isLoggedIn();
    if (this.isLoggedIn) {
      this.userProfile.set(await this.keycloak.loadUserProfile());
    }
  }

  get filters(): FormGroup {
    return this.filterForm.get('filters') as FormGroup;
  }
  checkEmptyArray(el:any){
    return el.length != 0
  }
  private navigateToDetail(uuid: string) {
    const currentUrl = this.router.url;
    const urlSegments = currentUrl.split('/');
    urlSegments.pop();
    urlSegments.push('punti-campionamento');
    urlSegments.push(uuid.toString());
    const newUrl = urlSegments.join('/');
    this.router.navigate([newUrl]);
  }
  ngOnDestroy(){
    this.queryService.store.setKey('list', [])
  }
}
